/**
 * Layout - Main Application Layout
 * 
 * Architecture: Navbar Top, Sidebar Below (allows dropdown to overflow)
 */

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { MobileMenuProvider } from '@/context/MobileMenuContext';

export function Layout() {
  return (
    <MobileMenuProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
        {/* Navbar spans full width at top */}
        <Navbar />
        
        {/* Sidebar + Main content below navbar */}
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 overflow-y-auto p-6 relative z-0">
            <Outlet />
          </main>
        </div>
      </div>
    </MobileMenuProvider>
  );
}
